import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/data/site";

export function Footer() {
  return (
    <footer className="bg-navy-dark text-white" data-testid="site-footer">
      <div className="container-pn grid grid-cols-1 gap-10 py-16 md:grid-cols-3">
        <div className="md:col-span-1">
          <Link
            to="/"
            data-testid="footer-logo-home"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 transition-opacity hover:opacity-80"
          >
            <span className="flex h-9 w-9 items-center justify-center bg-white font-heading text-lg font-black text-navy">
              HH
            </span>
            <span className="font-heading text-lg font-extrabold tracking-tight">HAYS HOLDINGS INC</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
            Your distribution and Amazon marketplace growth partner. We help manufacturers expand
            distribution, grow online sales, and scale revenue.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-orange-light">For Manufacturers</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li><Link to="/contact" className="hover:text-white">Become a Brand Partner</Link></li>
            <li><Link to="/contact" className="hover:text-white">Schedule a Discovery Call</Link></li>
            <li><Link to="/contact" className="hover:text-white">Request Partnership Review</Link></li>
            <li><Link to="/login" className="hover:text-white">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-orange-light">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-orange-light" /> {CONTACT.phone}</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-orange-light" /> {CONTACT.email}</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-orange-light" /> {CONTACT.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-pn flex flex-col items-center justify-between gap-2 py-6 text-xs text-white/40 sm:flex-row">
          <span>© {new Date().getFullYear()} Hays Holdings Inc. All rights reserved.</span>
          <span>Distribution · Amazon Growth · Brand Partnerships</span>
        </div>
      </div>
    </footer>
  );
}
